import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoundsListComponent } from './rounds-list/rounds-list.component';
import { RoundsCreateComponent } from './rounds-create/rounds-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: RoundsListComponent,
        data: {
          title: "Rounds List",
          breadcrumb: "Rounds List"
        }
      },
      {
        path: 'create',
        component: RoundsCreateComponent,
        data: {
          title: "Create Rounds",
          breadcrumb: "Create Rounds"
        }
      },
      {
        path: 'edit/:id',
        component: RoundsCreateComponent,
        data: {
          title: "Edit Rounds",
          breadcrumb: "Edit Rounds"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class RoundsRoutingModule { }
